import React, { useEffect } from 'react';
import InputMask from 'react-input-mask';
import { Input } from '@material-ui/core';

export default function PhoneMask(props) {
  const beforeMaskedValueChange = (newState) => {
    let { value } = newState;

    const newValue = value.replace(/\D/g, '');

    if (newValue.length > 12) {
      value = newValue.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
      return {
        ...newState,
        value,
      };
    }

    return {
      ...newState,
      value,
    };
  };

  const getFormat = (value) => {
    if (value?.replace(/\D/g, '')?.startsWith('0800') || value?.replace(/\D/g, '')?.startsWith('0300')) {
      if (value?.replace(/\D/g, '')?.length < 10) return '9999 999 999';
      else if (value?.replace(/\D/g, '')?.length >= 10) return '9999 999 9999';
      return '9999 999 9999';
    } else if (value?.replace(/\D/g, '')?.length < 10) return '(99) 9999-9999';
    else if (value?.replace(/\D/g, '')?.length === 10) return '(99) 9999-99999';
    else if (value?.replace(/\D/g, '')?.length > 10) return '(99) 99999-9999';
    return '(99) 9999-9999';
  };

  useEffect(() => {
    getFormat();
  }, [props.value]);

  return (
    <>
      <InputMask
        disabled={props.isDisabled}
        mask={getFormat(props.value)}
        {...props}
        inputRef={null}
        maskChar={null}
        beforeMaskedValueChange={beforeMaskedValueChange}
      >
        {(props) => (
          <Input
            {...props}
            disabled={props.isDisabled}
            fullWidth
            onBlur={null}
            label="Phone"
            id="phone"
          />
        )}
      </InputMask>
    </>
  );
}
